// This file intentionally left a JavaScript because the TypeScript types don't
// actually have `Chart` listed.

import { Chart } from "react-chartjs-2";
import { formatThousand } from "app/utils";

const { draw: original } = Chart.controllers.doughnut.prototype;

Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
  draw() { /* eslint-disable no-underscore-dangle */
    original.apply(this);
    // eslint-disable-next-line no-restricted-globals
    const { width: screenWidth } = screen;
    const { width, height, ctx } = this.chart.chart;
    const fontSize = (height / 114).toFixed(2);

    const { data } = this.chart.config.data.datasets[0];
    const displayCount = this.chart.getDatasetMeta(0).data
      .filter(({ hidden }) => !hidden)
      .map(({ _index }) => data[_index])
      .reduce((left, right) => left + right, 0);

    const text = formatThousand(displayCount).toString();

    ctx.font = `${fontSize}em sans-serif`;
    ctx.textBaseline = "middle";
    ctx.fillText(
      text,
      Math.round((width - ctx.measureText(text).width) / 2),
      height / (screenWidth > 1200 && screenWidth <= 1527 ? 2.5 : 2.3)
    );
  }
});
